import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import attachmentItemsPagingDetails from 'owa-service/lib/factory/attachmentItemsPagingDetails';
import type AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import type AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import attachmentItemsSort from 'owa-service/lib/factory/attachmentItemsSort';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import searchAttachmentDataProviderItemsOperation from 'owa-service/lib/operation/searchAttachmentDataProviderItemsOperation';
import searchAttachmentDataProviderItemsRequest from 'owa-service/lib/factory/searchAttachmentDataProviderItemsRequest';
import type SearchAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/SearchAttachmentDataProviderItemsResponse';
import searchGDriveFileProviderItems from './searchGDriveFileProviderItems';
import searchMailMessageFileProviderItems from './searchMailMessageFileProviderItems';
import { defaultSort } from '../constants';

export function searchFileProviderItems(
    fileProviderType: AttachmentDataProviderType,
    fileProviderId: string,
    query: string,
    folderId?: string,
    location?: string,
    pagingMetadata: AttachmentItemsPagingMetadata = null,
    sort?: AttachmentItemsSort
): Promise<SearchAttachmentDataProviderItemsResponse> {
    if (fileProviderType === AttachmentDataProviderType.GDrive) {
        return searchGDriveFileProviderItems(query, location);
    }
    if (fileProviderType === AttachmentDataProviderType.MailMessage) {
        return searchMailMessageFileProviderItems(query);
    }
    const request = searchAttachmentDataProviderItemsRequest({
        AttachmentDataProviderId: fileProviderId,
        Query: query,
        Paging: attachmentItemsPagingDetails({
            Sort: sort || attachmentItemsSort(defaultSort),
            FolderId: folderId,
            Location: location,
            RequestedData: indexedPageView({
                BasePoint: 'Beginning',
                Offset: 0,
                MaxEntriesReturned: 100,
            }),
            PagingMetadata: pagingMetadata,
        }),
    });

    return searchAttachmentDataProviderItemsOperation({
        request: request,
    });
}
